import { useContext } from "react";
import { NavContext } from ".";
import {
  Stack,
  Divider,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from "@chakra-ui/react";
import Sidebar from "../../pages/Sidebar";

const MobileSidebar = () => {
  const { isOpen, onClose } = useContext(NavContext);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="left">
      <DrawerOverlay />
      <DrawerContent layerStyle="neutral" data-cy="drawer">
        <DrawerCloseButton top="32px"/>
        <Stack spacing={2} fontSize="sm">
          <Sidebar />
          <Divider />
        </Stack>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileSidebar;
